import { Injectable } from "@angular/core"
import { DisplayDataResolver } from "@pl/pl-lib/common"
import { isEmpty } from "lodash"
import { Club } from "../../models/club"

@Injectable({
  providedIn: "root",
})
export class ClubDisplayDataResolver
  implements DisplayDataResolver<Club>
{
  typeDisplayName = "Club"

  constructor() {}

  getIcon(entity: Club): string | undefined {
    return "k-i-inherited"
  }

  getImage(entity: Club): string | undefined {
    return undefined
  }

  getSubTitle(entity: Club): string | undefined {
    return undefined
  }

  getTitle(entity: Club): string {
    return entity.name
  }

  getShortTitle(entity: Club): string {
    return entity.id
  }

  getItemHref(entityOrID: Club | string): string | undefined {
    if (isEmpty(entityOrID)) {
      return "/app/club"
    }
    if (typeof entityOrID === "string") return "/app/club/" + entityOrID
    return "/app/club/" + entityOrID.id
  }
}
